const getPmcId = (props) => props?.match?.params?.PMCId;
const getBuildingId = (props) => props?.match?.params?.buildingId;
const getDoorId = (props) => props?.match?.params?.doorId;
const getPersonId = (props) =>
  props?.match?.params?.staffId || props?.match?.params?.residentId;
const getIsCreate = (props) => props?.match?.path.includes('create');

const getListParams = (state, key) => state?.lists?.[key] || {};
const getIsLoading = (state) => !!state?.common?.loading?.length;
const getIsDrawerOpen = (state) => state?.common?.isDrawerOpen;
const isNavigationShown = (state) => state?.common?.isNavigationShown;
const getFormState = (state, formName) => state?.form?.[formName] || {};
const getCurrentUser = (state) => state?.common?.currentUser || {};
const getLogoUrl = (state) => {
  const { pmcRole, pmcRoles = [] } = getCurrentUser(state);
  const roleWithLogoUrl = [pmcRole, ...pmcRoles]
    ?.filter(Boolean)
    ?.find(({ logoUrl }) => logoUrl);
  return roleWithLogoUrl?.logoUrl;
};
const getIsMobileScreen = (state) => state?.common?.isMobileScreen || false;
const getTodayCount = (state) => state?.todayCount;

export {
  getPmcId,
  getBuildingId,
  getDoorId,
  getPersonId,
  getIsCreate,
  getListParams,
  getIsLoading,
  getIsDrawerOpen,
  isNavigationShown,
  getFormState,
  getCurrentUser,
  getLogoUrl,
  getIsMobileScreen,
  getTodayCount,
};
